import { Button,  } from 'antd';
import React, { memo, useMemo } from 'react';
import { ScheduleTwoTone } from '@ant-design/icons';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import { AssetRepossessionResponse,  } from '../../../../services/assets';
import { toCurrency } from '../../../../utils/utils';

type RepossessionTableProps = {
  onOpenSchedule: (Repossession: AssetRepossessionResponse) => void;
  Repossessions?: AssetRepossessionResponse[];
};

const RepossessionTable = (props: RepossessionTableProps) => {
  const { onOpenSchedule, Repossessions } = props;

  const columns = useMemo<DataGridColDef<AssetRepossessionResponse>[]>(
    () => [
      {
        comcode: 'rep.repdecisionlabel',
        dataIndex: 'repdecisionlabel',
        width: 200,
        fixed: 'left',
      },
      {
        comcode: 'rep.repcomment',
        dataIndex: 'repcomment',
        width:300,
        align: 'left',
      },
      {
        comcode: 'rep.repevaldate',
        dataIndex: 'repevaldate',
        width: 150,
        align: 'left',
      },
      {
        comcode: 'rep.marketvalue',
        dataIndex: 'marketvalue',
        width: 100,
        align: 'left',
      },
      {
        comcode: 'rep.damage',
        dataIndex: 'damage',
        width: 100,
        align: 'left',
      },
      {
        comcode: 'rep.recondamount',
        dataIndex: 'recondamount',
        width: 100,
        align: 'left',
      },
      {
        comcode: 'rep.coefficient',
        dataIndex: 'coefficient',
        width: 80,
        align: 'left',
      },     
      {
        comcode: 'rep.assetfinrvamount',
        dataIndex: 'assetfinrvamount',
        width: 150,
        align: 'left',
        render:(value, record)=> toCurrency(value),
      },
      {
        title: 'Actions',
        key: 'actions',
        render: (text, record) => (
          <Button
            icon={<ScheduleTwoTone twoToneColor="#eb2f96" />}
            onClick={() => {
              onOpenSchedule(record);
            }}
          />
        ),
        fixed: 'right',
        width: 80,
      },
    ],
    [onOpenSchedule]
  );

  return (
    <DataGrid
      dataSource={Repossessions}
      columns={columns}
      rowKey={(record) => record.repid}
    />
  );
};

export default memo(RepossessionTable);
